'use client'
import Link from 'next/link'

import { useEffect, useState, useRef } from 'react'
import Nav from './components/Nav'
import { openCart } from '@/utils/openCart'
import CartLength from './components/CartLength'
import Image from 'next/image'
import User from './components/User'
import SearchPopup from './components/SearchPopup'
import CategorySelect from './components/CategorySelect'
import { currencyOptions, languageOptions2 } from '@/data/footer'
import { socialLinks } from '@/data/socials'
import { useContextElement } from '@/context/Context'
import styles from '@/components/headers/Header9.module.css'
import { Flex } from 'antd'
import HeaderSearchBox from './components/HeaderSearchBox'

export default function Header9({
  TopEnable,
  TopTitle,
  TopBGColor,
  TopFontColor,
  IsInternalURL,
  LinkURL,
  cusomNav,
  headerStyle,
  homeContent,
  brand,
  storeInfo,
  categoryItems,
}) {
  const { isLogin } = useContextElement()
  const headerRef = useRef(null)

  const [scrollDirection, setScrollDirection] = useState('down')

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY > 250) {
        if (currentScrollY > lastScrollY.current) {
          // Scrolling down
          setScrollDirection('down')
        } else {
          // Scrolling up
          setScrollDirection('up')
        }
      } else {
        // Below 250px
        setScrollDirection('down')
      }

      lastScrollY.current = currentScrollY
    }

    const lastScrollY = { current: window.scrollY }

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll)

    // Cleanup: remove event listener when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  useEffect(() => {
    if (!headerRef.current) return

    const observer = new ResizeObserver(() => {
      const h = headerRef.current.offsetHeight
      document.documentElement.style.setProperty('--header-height', `${h}px`)
    })

    observer.observe(headerRef.current)

    return () => observer.disconnect()
  }, [])

  return (
    <header
      ref={headerRef}
      id="header"
      className={`header header_sticky header_sticky ${
        headerStyle?.HeaderOnTopStyle === 1
          ? 'header_sticky-active'
          : scrollDirection === 'up'
            ? 'header_sticky-active'
            : 'position-absolute'
      }`}
    >
      {/* 最上方 top bar */}
      <div
        className="header-top align-items-center justify-content-center"
        style={{
          color: headerStyle.TopFontColor ? headerStyle.TopFontColor : '#000',
          background: headerStyle?.TopBGColor
            ? headerStyle?.TopBGColor
            : 'black',
          display: headerStyle?.TopEnable ? 'flex' : 'none',
          height: '42px',
          padding: '0px',
        }}
      >
        <Link
          href={headerStyle.LinkURL ? headerStyle.LinkURL : '/'}
          style={{
            color: headerStyle?.TopFontColor
              ? headerStyle?.TopFontColor
              : '#FFFFFF',
          }}
        >
          <p
            className="mx-auto mb-0"
            style={{
              fontSize: headerStyle?.TopFontSize ?? '30px',
              ...(headerStyle?.TopFont
                ? { fontFamily: headerStyle.TopFont }
                : {}),
            }}
          >
            {headerStyle?.TopTitle}
          </p>
        </Link>

        {/* <ul className="list-unstyled d-flex flex-1 gap-3 m-0">
          <li>
            <a href="#" className="menu-link menu-link_us-s color-white">
              Shipping
            </a>
          </li>
          <li>
            <a href="#" className="menu-link menu-link_us-s color-white">
              FAQ
            </a>
          </li>
          <li>
            <a href="#" className="menu-link menu-link_us-s color-white">
              Contact
            </a>
          </li>
          <li>
            <a href="#" className="menu-link menu-link_us-s color-white">
              Track Order
            </a>
          </li>
        </ul> */}
        {/* <div className="heeader-top__right flex-1 d-flex gap-1 justify-content-end">
          <ul className="social-links list-unstyled d-flex flex-wrap mb-0">
            {socialLinks.map((link, index) => (
              <li key={index}>
                <a
                  href={link.href}
                  className="footer__social-link d-block color-white"
                >
                  <svg
                    className={link.className}
                    width={link.width}
                    height={link.height}
                    viewBox={link.viewBox}
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <use href={link.icon} />
                  </svg>
                </a>
              </li>
            ))}
          </ul>
          <select
            className="form-select form-select-sm bg-transparent color-white"
            name="store-language"
          >
            {languageOptions2.map((option, index) => (
              <option key={index} value={option.value}>
                {option.text}
              </option>
            ))}
          </select>
          <select
            className="form-select form-select-sm bg-transparent color-white"
            name="store-currency"
          >
            {currencyOptions.map((option, index) => (
              <option
                key={index}
                className="footer-select__option"
                value={option.value}
              >
                {option.text}
              </option>
            ))}
          </select>
        </div> */}
      </div>

      <div
        className={`header-desk d-flex justify-content-between py-2 px-3`}
        style={{
          background: headerStyle?.HeaderBGColor
            ? headerStyle?.HeaderBGColor
            : 'white',
          color: headerStyle?.HeaderFontColor
            ? headerStyle?.HeaderFontColor
            : 'black',
        }}
      >
        <div className={`logo ${styles.logo} m-0`}>
          <Link href="/">
            <Image
              src={headerStyle?.LogoPath}
              width={100}
              height={25}
              alt="logo"
              style={{
                width: '75px', // 寬度自動
                height: 'auto', // 高度自動
                maxWidth: '100%', // 不超出容器
                objectFit: 'contain', // 保持比例不裁切
              }}
            />
          </Link>
        </div>

        <nav className="navigation mx-auto mx-xxl-0">
          <ul className="navigation__list list-unstyled d-flex">
            <Nav
              cusomNav={cusomNav}
              headerStyle={headerStyle}
              brand={brand}
              categoryItems={categoryItems}
            />
          </ul>
          {/* <!-- /.navigation__list --> */}
        </nav>
        {/* <!-- /.navigation --> */}

        <div className="header-tools d-flex align-items-center">
          <HeaderSearchBox headerStyle={headerStyle} variant="desktop" />
          {/* <!-- /.header-tools__item hover-container --> */}

          <div
            className={`${!isLogin && 'header-tools__item'} hover-container ${styles.hoverContainer}`}
          >
            <a className="header-tools__item js-open-aside" href="#">
              <User headerStyle={headerStyle} />
            </a>
            {isLogin && (
              <div className={`${styles.memberMenu}`} role="menu">
                <div className="d-flex flex-column text-center">
                  <a
                    href="/MemberCenter/account_dashboard"
                    role="menuitem"
                    className="mb-2"
                  >
                    會員專區
                  </a>
                  <a
                    href="/MemberCenter/account_orders?page=1"
                    role="menuitem"
                    className="mb-2"
                  >
                    訂單查詢
                  </a>
                  <a
                    href="/MemberCenter/account_wishlist"
                    role="menuitem"
                    className="mb-2"
                  >
                    我的願望清單
                  </a>
                  <a
                    href="/MemberCenter/account_coupon"
                    role="menuitem"
                    className="mb-2"
                  >
                    我的優惠券
                  </a>
                  <a href="/Logout" role="menuitem">
                    會員登出
                  </a>
                </div>
              </div>
            )}
          </div>

          {storeInfo?.WishlistButtonEnable && (
            <Link
              className="header-tools__item"
              href="/MemberCenter/account_wishlist"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                style={{ color: headerStyle?.HeaderFontColor || '#000' }}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use href="#icon_heart" />
              </svg>
            </Link>
          )}

          {storeInfo?.CartButtonEnable && (
            <a
              onClick={() => openCart()}
              className="header-tools__item header-tools__cart js-open-aside"
            >
              <svg
                className="d-block"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                style={{ color: headerStyle?.HeaderFontColor || '#000' }}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <use href="#icon_cart" />
              </svg>
              <span
                className="cart-amount d-block position-absolute js-cart-items-count"
                style={{
                  background: headerStyle.HeaderCartBGColor
                    ? headerStyle.HeaderCartBGColor
                    : '#b9a16b',
                  color: headerStyle.HeaderCartBGColor
                    ? headerStyle.HeaderCartFontColor
                    : '#ffffff',
                }}
              >
                <CartLength />
              </span>
            </a>
          )}
        </div>
        {/* <!-- /.header__tools --> */}
      </div>
      {/* <!-- /.header-desk header-desk_type_1 --> */}
    </header>
  )
}
